export enum SoftwareEscrowRoutesEnum {
  Overview = 'overview',
  Agreement = 'agreement',
  Deposits = 'deposits',
  Settings = 'settings',
  Members = 'members',
  Reports = 'reports',
}

export enum SoftwareEscrowSettingsRoutesEnum {
  Agreement = 'agreement',
  Beneficiary = 'beneficiary',
  Depositor = 'depositor',
  Technical = 'technical',
}
